import axios from 'axios';
import constants from './constants';

class Consumer {
     constructor() {
          this.services = constants.services;
     }

     getCategories() {
          return axios.get(this.services.getService("categories", "all"));
     }

     getDepartments() {
          return axios.get(this.services.getService("departments", "all"));
     }

     getCities() {
          return axios.get(this.services.getService("cities", "all"));
     }

     getCitiesDepartment(department) {
          department = department.replace(" ", "+");
          var url = this.services.getService("cities", "by_department");
          url = url.replace("{deptName}", department);
          return axios.get(url);
     }

     getPointsCity(cityCode) {
          var url = this.services.getService("points", "by_city");
          url = url.replace("{cityCode}", cityCode);
          return axios.get(url);
     }

     getPointsAround(lng, lat, limit) {
          var url = this.services.getService("points", "around_location");
          url = url.replace("{lng}", lng);
          url = url.replace("{lat}", lat);
          url = url.replace("{limit}", limit);
          return axios.get(url);
     }
}

export default new Consumer();